export default __webpack_public_path__ + "static/media/img-0463-montenegro-half-face.eeb5fe9b.png";